import { connect } from "react-redux";
import get from "lodash/get";

import { getPermissions as onGetPermissions } from "../../actions/permissionsAction";

const mapStateToProps = (state) => ({
  dataState: state.permissions.dataState,
  permissions: get(state, ["permissions", "permissions"], null),
  errors: get(state, ["permissions", "errors"], null),
});

const mapDispatchToProps = { onGetPermissions };

const withPermissions = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withPermissions };
